import { Tabs } from "@circleco/compass/components/Tabs";

import { useIsMobileShellEnabled } from "@/react/components/Mobile/hooks/useIsMobileShellEnabled";
import { BotChatList } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/BotChatList";
import {
  TAB_AGENTS,
  TAB_INBOX,
  TAB_UNREAD,
} from "@/react/components/shared/DirectMessages/constants";
import { useDirectMessagesTabs } from "@/react/components/shared/DirectMessages/useDirectMessagesTabs";

import { DMsList } from "./List";
import { ListWrapper } from "./List/ListWrapper";
import { NoUnreadMessages } from "./NoUnreadMessages";

export const TabHeader = () => {
  const {
    handleTabChange,
    selectedValue,
    shouldShowAgentsTab,
    shouldShowMessagesTab,
    tabs,
    unreadChatRoomUuids,
    unreadChatRoomsCount,
  } = useDirectMessagesTabs();
  const isMobileShellEnabled = useIsMobileShellEnabled();

  const shouldHideInlineTabs = isMobileShellEnabled;

  return (
    <div className="bg-primary size-full overflow-hidden">
      {!shouldHideInlineTabs && (
        <div className="border-primary h-14 border-b px-6 pb-4">
          <Tabs.Root
            tabs={tabs}
            selectedValue={selectedValue}
            onValueChange={handleTabChange}
          />
        </div>
      )}
      {shouldShowMessagesTab && (
        <>
          {selectedValue === TAB_INBOX && <DMsList />}
          {selectedValue === TAB_UNREAD &&
            (unreadChatRoomsCount === 0 ? (
              <ListWrapper>
                <NoUnreadMessages />
              </ListWrapper>
            ) : (
              <DMsList unreadChatRoomUuids={unreadChatRoomUuids} />
            ))}
        </>
      )}
      {shouldShowAgentsTab && selectedValue === TAB_AGENTS && (
        <ListWrapper>
          <BotChatList isRightActionBlock isRenderedOnHeader />
        </ListWrapper>
      )}
    </div>
  );
};
